module.exports = {"130172100":"丘头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130172.json
// module id = 162
// module chunks = 0